// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2kQuh","header":"MergedInvoice_header__3BLQw"};